import { axiosInstance as axios } from "services";

export const updateCompanyPrice = async (companyId, body) => {
  const { data } = await axios.put(`/admin/subscription/company/${companyId}/price`, body);
  if (!data.success) throw new Error(data.error?.message || "Failed to update company price");
  return data;
};

